<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7.5 3L15 12.5976H0L7.5 3Z" fill="url(#paint0_linear_7746_35646)" />
    <defs>
      <linearGradient id="paint0_linear_7746_35646" x1="7.5" y1="3" x2="7.5" y2="12.5976" gradientUnits="userSpaceOnUse">
        <stop offset="0.395833" stop-color="#53CC58" />
        <stop offset="1" stop-color="#429746" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'Improvement',
};
</script>
